import { Bookmaker } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

/** Static bookmaker id/name list (aligned with `Bookmaker` / `BookmakerName`). */
export const staticBookmaker = createSimpleDictionary(
    [
        { id: Bookmaker.Sbo, name: 'SBO' },
        { id: Bookmaker.Ibc, name: 'IBC' },
        { id: Bookmaker.Sing, name: 'Singbet' },
        { id: Bookmaker.Pinna, name: 'Pinnacle' },
        { id: Bookmaker.Isn, name: 'ISN' },
        { id: Bookmaker.Betfair, name: 'Betfair' },
        { id: Bookmaker.Sportmonks, name: 'Sportmonks' },
        { id: Bookmaker.Sharpbet, name: 'Sharpbet' },
        { id: Bookmaker.Pinweb, name: 'PinWeb' },
        { id: Bookmaker.ThreeBet, name: '3et' },
        { id: Bookmaker.Matchbook, name: 'Matchbook' },
        { id: Bookmaker.Betdaq, name: 'Betdaq' },
    ],
    []
);
